import { HttpHeaders, HttpParams, HttpStatusCode } from "@angular/common/http";
import { protectedResources } from "@app/auth-config";
import { NextUrl, PagingOpts } from "@app/models/common";
import { GlobalConstants } from "@app/utils/global-constants";
import { getCurrentUserFromStorage } from "@app/utils/storage-utils";
import { environment } from "environments/environment";

export class BaseService {
    
    path ="";
    baseURL = "";

    constructor( ) {
        this.baseURL = window.location.protocol + "//" + window.location.host;
    }
    
	getUrl(url: string, pagingOpts : PagingOpts, qs? : any) {
        const ret: NextUrl = {nextUrl : url, params : new HttpParams()};
        
        if (pagingOpts.nextUrl) {
            ret.nextUrl = pagingOpts.nextUrl; 

        } else {
            if (pagingOpts.pageNumber) {
                ret.params=ret.params.set("pageNumber",pagingOpts.pageNumber);

            }
            if (pagingOpts.pageSize) {
                ret.params=ret.params.set("pageSize",pagingOpts.pageSize);
            }

            if (qs != 'undefined') {
                for (const key of Object.keys(qs)) {
                    ret.params=ret.params.set(key,qs[key])

                }

            }
                      
        }
        return ret;
    }
    
    setCustomRequestheaders() {
        const currentUser = getCurrentUserFromStorage();
        const headers = new HttpHeaders().set(GlobalConstants.GRAPH_TOKEN_HEADER, currentUser.accessToken||'');
        return headers;
    }
    checkStatusCode(error: any) {
        let msg = "Access to the backend failed " + (this.path ? "(" + this.path +  ")" : "") + " - ";
        let msgText = (error.statusText !== 'Unknown Error' ? error.statusText + ". " : "");
        if (error.status === 401) {
            msg += " (Unauthorized)";
        } else if (error.statusText.indexOf("Gateway Time-out") > -1 || 
                   error.statusText.indexOf("Bad Gateway") > -1)
         {
            msg += msgText + "The application may be updating. Please try again later or refresh screen.";
        } else {
            msg += msgText + "The error may be transient, please try again and refresh screen.";
        }
        return msg;
    }

    //If the user is using a vanity URL: intra.dev.apps.supplyontario, dev.apps.supplyontario.ca etc
    //it means they are in the cloud and we want want to use that based in the API call as it goes through front-door
    //or the application gateway. if you are using localhsot or the actual non-frontdoor/non-gateway url, use the emdpoint found in config
    
    getBaseURL() {
        if (this.baseURL.toLowerCase().indexOf("supplyontario") > -1) {
            return this.baseURL  + environment.backend.endpointPath;
        } else {
            return protectedResources.apiUrl.endpoint + environment.backend.endpointPath;
        }
    }
}